import * as React from "react";
import type { SVGProps } from "react";
const BarberShop = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0_4355_8609)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M9.0675 8.5903c-.7027.067-1.3514.2933-1.8752.6542-.1935.1332-.8446.6648-1.4469 1.1812-1.5585 1.3363-1.7157 1.3957-3.7237 1.406l-1.1865.0061-.1513.145c-.1924.1844-.2382.4018-.1317.6262.1093.2303 1.075 1.1519 1.5978 1.5248.8326.5939 2.0526 1.1199 3.0935 1.3338.683.1403 1.6275.194 2.2872.13 1.8677-.1814 3.2556-.6517 4.3769-1.4832.6266-.4646.5906-.4558.8787-.2156 1.2885 1.0737 3.322 1.7217 5.39 1.7176 1.648-.0032 3.1543-.4679 4.556-1.4055.5411-.3619 1.5832-1.3397 1.7079-1.6023.1062-.224.0605-.4414-.1319-.6258l-.1512-.145-1.4168-.0272c-1.3212-.0255-1.4367-.0352-1.711-.1444-.462-.184-1.126-.6517-1.9318-1.3611-.4082-.3592-.8917-.7677-1.0747-.9076-.7177-.549-1.5527-.8186-2.5305-.8169-.7699.0013-1.1947.1188-2.1902.606l-.806.3943-.806-.3946c-1.0995-.5382-1.7288-.6813-2.6226-.596"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="clip0_4355_8609">
        <path fill="transparent" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default BarberShop;
